<div *ngIf="entity?.id, else formTemplate">
  <div class="row wrapper border-bottom white-bg page-heading info-projeto">
    <div class="col-lg-10 title-projeto">
      <h2>Membro da Equipe</h2>
      <h3>Projeto</h3>
    </div>
    <div class="col-lg-2"></div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content box-content">
            <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>


<ng-template #formTemplate>

  <div class="info-page">
    <h3>{{ actionLabel }} Membro da Equipe</h3>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()">
    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Nome<sup class="text-danger ms-2">*</sup></label>
        <input type="text" id="name" class="form-control" formControlName="name" required maxlength="150" />
        <app-field-message [field]="fieldMessageRequired('name')" [erros]="fieldErros('name')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Organização</label>
        <input type="text" id="organization" class="form-control" formControlName="organization" maxlength="150" />
        <app-field-message [field]="fieldMessageRequired('organization')" [erros]="fieldErros('organization')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Departamento</label>
        <input type="text" id="department" class="form-control" formControlName="department" maxlength="150" />
        <app-field-message [field]="fieldMessageRequired('department')" [erros]="fieldErros('department')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">E-mail</label>
        <input type="text" id="email" class="form-control" formControlName="email" maxlength="150" />
        <app-field-message [field]="fieldMessageRequired('email')" [erros]="fieldErros('email')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Telefone</label>
        <input type="text" id="fone" class="form-control" formControlName="fone" maxlength="11" />
        <app-field-message [field]="fieldMessageRequired('fone')" [erros]="fieldErros('fone')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-6">
        <label class="col-sm-12 pb-1">Responsabilidades</label>
        <ng-select id="equiprole" class="ng-select-alternative" [multiple]="true" [items]="responsabilidadesList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="equiprole"></ng-select>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button *ngIf="this.entity?.id && this.canSave" class="btn btn-danger m-r-xxl" (click)="confirmExcluir()" type="button">Excluir</button>
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
        <button *ngIf="this.canSave" class="btn btn-primary" type="submit">Salvar</button>
      </div>
    </div>
  </form>
  <app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>

</ng-template>